import _ from 'lodash';

const HelperObject = {
	
	groupBy: ( payload, key ) => {
		const collection = {};
		
		_.forEach( payload, ( item ) => {
			const guid = _.get( item, key, null );
			
			if( guid !== null ) {
				collection[ guid ] = item;
			}
		});
		
		return collection;
	},
	
	// Simple function to group payload by guid
	groupByGuid: ( payload ) => {
		return HelperObject.groupBy( payload, 'guid' );
	},
	
	isValid: (o) => {
		return typeof o !== 'undefined' && o !== null && o !== false && o !== 'false';
	}
}

export default HelperObject
